import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { date, constants } from 'common/helpers'

import composeDialogModal from 'components/modal/DialogModal/composeDialogModal'

import messages from './messages'


const SkipAMonthSuccessModal = composeDialogModal({
  name: constants.modals.SkipAMonthSuccess,
  title: ({ data: { monthCount } }) => ({
    ...messages.title,
    values: { count: monthCount },
  }),
  contentMessage: ({ nextShippingDate, data: { monthCount } }) => {
    const nextShippingMonth = date.formatDate(nextShippingDate, 'MMM DD')

    return {
      ...messages.text,
      values: { dateRange: nextShippingMonth, count: monthCount },
      tag: 'div',
    }
  },
  propTypes: {
    nextShippingDate: PropTypes.any.isRequired,
  },
})

export default connect({
  nextShippingDate: 'models.subscription.nextShippingDate',
})(SkipAMonthSuccessModal)
